import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../AxiosInstance";
import { useAuth } from "../context/auth";
import { BASE_URL } from "../config/BaseUrls";
import { LanguageContext } from "../context/LanguageContext";
import { ensureHttps } from "../utils/urlHelpers";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const PersonalSeller = () => {
  const { lg } = useContext(LanguageContext);

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);



  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const [alertVisible, setAlertVisible] = useState(false);

  const handleSaveChanges = () => {
    setAlertVisible(true); // Show the alert
    setAlertVisibleAdd3(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd(false);
    setAlertVisibleAdd4(false);
    setTimeout(() => setAlertVisible(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlert = () => {
    setAlertVisible(false); // Manually close the alert
  };

  const [alertVisibleAdd, setAlertVisibleAdd] = useState(false);

  const handleSaveChangesAdd = () => {
    setAlertVisibleAdd(true); // Show the alert
    setAlertVisibleAdd3(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd4(false);
    setAlertVisible(false);
    setTimeout(() => setAlertVisibleAdd(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd = () => {
    setAlertVisibleAdd(false); // Manually close the alert
  };

  const [alertVisibleAdd2, setAlertVisibleAdd2] = useState(false);

  const handleSaveChangesAdd2 = () => {
    setAlertVisibleAdd2(true); // Show the alert
    setAlertVisibleAdd3(false);
    setAlertVisibleAdd4(false);
    setAlertVisibleAdd(false);
    setAlertVisible(false);
    setTimeout(() => setAlertVisibleAdd2(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd2 = () => {
    setAlertVisibleAdd2(false); // Manually close the alert
  };

  const [alertVisibleAdd3, setAlertVisibleAdd3] = useState(false);

  const handleSaveChangesAdd3 = () => {
    setAlertVisibleAdd3(true); // Show the alert
    setAlertVisibleAdd4(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd(false);
    setAlertVisible(false);
    setTimeout(() => setAlertVisibleAdd3(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd3 = () => {
    setAlertVisibleAdd3(false); // Manually close the alert
  };

  const [alertVisibleAdd4, setAlertVisibleAdd4] = useState(false);

  const handleSaveChangesAdd4 = () => {
    setAlertVisibleAdd4(true); // Show the alert
    setAlertVisibleAdd3(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd(false);
    setAlertVisible(false);

    setTimeout(() => setAlertVisibleAdd4(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd4 = () => {
    setAlertVisibleAdd4(false); // Manually close the alert
  };

  const [alertVisibleAdd5, setAlertVisibleAdd5] = useState(false);

  const handleSaveChangesAdd5 = () => {
    setAlertVisibleAdd5(true); // Show the alert
    setAlertVisibleAdd4(false); // Show the alert

    setAlertVisibleAdd3(false);
    setAlertVisibleAdd2(false);
    setAlertVisibleAdd(false);
    setAlertVisible(false);

    setTimeout(() => setAlertVisibleAdd5(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlertAdd5 = () => {
    setAlertVisibleAdd5(false); // Manually close the alert
  };
  //=========================== INTGRATION ================================
  const [auth, setAuth] = useAuth(); // If using Context API

  const userId = auth?.user?._id;

  const [user, setUser] = useState({
    name: "",
    city: "",
    country: "",
    dateOfBirth: "",
    gender: "",
    aboutMe: "",
    storeName: "",
    storeAddress: "",
    surName: "",
    favoriteGenres: "",
    fbLinks: [],
    instaLinks: [],
    tiktokLinks: [],
    xLinks: [],
    linkdlnLinks: [],
  });

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`api/v1/auth/user-profile/${userId}`);
        setUser(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);
  // ✅ Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Save file to state for backend upload
      setUser((prevUser) => ({
        ...prevUser,
        imageFile: file, // 👈 this is needed to send file to FormData
      }));

      // Show preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
        localStorage.setItem("profileImage", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const formatDate = (date) => {
    if (!date) return ""; // If no date is present, return empty string
    return date.split("T")[0]; // Split by 'T' and return only the date part
  };

  const handleUpdateProfile = async () => {
    try {
      const formData = new FormData();

      // Append all your profile fields
      formData.append("name", user.name);
      formData.append("storeName", user.storeName);
      formData.append("storeAddress", user.storeAddress);

      formData.append("surName", user.surName || "");
      formData.append("favoriteGenres", user.favoriteGenres || "");
      formData.append("city", user.city || "");
      formData.append("country", user.country || "");
      formData.append("dateOfBirth", user.dateOfBirth || "");
      formData.append("gender", user.gender || "");
      formData.append("fbLinks", user.fbLinks || "");
      formData.append("instaLinks", user.instaLinks || "");
      formData.append("tiktokLinks", user.tiktokLinks || "");
      formData.append("xLinks", user.xLinks || "");
      formData.append("linkdlnLinks", user.linkdlnLinks || "");
      formData.append("aboutMe", user.aboutMe || "");
      formData.append("sellerAdress", user.sellerAdress || "");
      formData.append("sellerCity", user.sellerCity || "");
      // Append image if available
      if (user.imageFile) {
        formData.append("image", user.imageFile);
      }

      const response = await axios.put(
        `api/v1/auth/update-profile/${userId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        setUser(response.data.data); // Update frontend state
        window.location.reload(); // Reload the page to reflect changes
        handleSaveChanges(true); // Close editing mode
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Error updating profile");
    }
  };

  //====================INTGRATION======================

  return (
    <>
      <div className="profilheder">
        <Header3 />
      </div>

      {/* Alert */}

      {alertVisible && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your profile information has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlert}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Facebook link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd2 && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Instagram link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd2}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd3 && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your X link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd3}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd4 && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Linkedin link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd4}
          >
            ×
          </div>
        </div>
      )}

      {alertVisibleAdd5 && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "1%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Tik Tok link has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlertAdd5}
          >
            ×
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 lg:!px-0 py-6">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          {/* Sidebar */}
          <div className="w-full lg:w-64 flex-shrink-0">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              {/* Profile Image Section */}
              <div className="flex flex-col items-center mb-6">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <div className="relative mb-4">
                  <img
                    src={
                      selectedImage ||
                      (user?.profileImage
                        ? user?.profileImage?.startsWith("http")
                          ? ensureHttps(user?.profileImage) // ✅ external URL - ensure HTTPS
                          : ensureHttps(`${BASE_URL}/uploads/${user.profileImage}`) // ✅ internal URL - ensure HTTPS
                        : require("../pages/image/addphotoiconplus.png"))
                    }
                    alt="Profile"
                    className="rounded-full w-24 h-24 object-cover cursor-pointer border-2 border-gray-200 hover:border-[#34C3C9] transition-colors"
                    onClick={handleButtonClick}
                    onError={(e) => {
                      e.target.src = require("../pages/image/addphotoiconplus.png");
                    }}
                  />
                  <div className="absolute bottom-0 right-0 bg-[#34C3C9] rounded-full p-1.5 cursor-pointer hover:bg-[#2BB3BA] transition-colors">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">{user.name}</h2>
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                  onClick={handleButtonClick}
                >
                  {lg?.uploadp || "Update photo"}
                </button>
              </div>

              {/* Navigation Links */}
              <div className="space-y-2 border-t border-gray-200 pt-4">
                <Link
                  to="/profile"
                  className="flex items-center px-2 py-2.5 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                >
                  {lg?.pprofile || "Personal Profile"}
                </Link>
                <Link
                  to="/accountnotification"
                  className="flex items-center px-2 py-2.5 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                >
                  {lg?.accnotifi || "Account Notification"}
                </Link>
                <Link
                  to="/personal-seller"
                  className="flex items-center px-2 py-2.5 text-base font-semibold text-[#34C3C9] bg-[#34C3C91a] rounded-lg"
                >
                  Bookseller's details
                </Link>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1">
            <style>{`
              .phone-input-wrapper .react-tel-input .form-control {
                border: 1px solid #d1d5db !important;
                border-left: none !important;
                border-radius: 0 8px 8px 0 !important;
                padding: 10px 16px !important;
                height: auto !important;
                max-width: 100% !important;
                width: 100% !important;
                font-size: 16px !important;
                color: #111827 !important;
                line-height: 1.5 !important;
              }
              .phone-input-wrapper .react-tel-input .flag-dropdown {
                border: 1px solid #d1d5db !important;
                border-right: none !important;
                border-radius: 8px 0 0 8px !important;
                background-color: white !important;
                padding: 10px 12px !important;
                height: auto !important;
                min-height: 42px !important;
              }
              .phone-input-wrapper .react-tel-input .flag-dropdown.open {
                border-color: #34C3C9 !important;
              }
              .phone-input-wrapper .react-tel-input .form-control:focus {
                border-color: #34C3C9 !important;
                box-shadow: 0 0 0 2px rgba(52, 195, 201, 0.2) !important;
              }
              .phone-input-wrapper .react-tel-input .flag-dropdown:focus-within {
                border-color: #34C3C9 !important;
                box-shadow: 0 0 0 2px rgba(52, 195, 201, 0.2) !important;
              }
            `}</style>
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:p-8">
              <form onSubmit={(e) => { e.preventDefault(); handleUpdateProfile(); }} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2">
                    <label htmlFor="storeName" className="block text-sm font-semibold text-gray-700 mb-2">
                      Store's name
                    </label>
                    <input
                      type="text"
                      id="storeName"
                      name="storeName"
                      value={user.storeName || ""}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label htmlFor="storeAddress" className="block text-sm font-semibold text-gray-700 mb-2">
                      Address
                    </label>
                    <input
                      type="text"
                      id="storeAddress"
                      name="storeAddress"
                      value={user.storeAddress || ""}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>

                  <div>
                    <label htmlFor="sellerCity" className="block text-sm font-semibold text-gray-700 mb-2">
                      City
                    </label>
                    <input
                      type="text"
                      id="sellerCity"
                      name="sellerCity"
                      value={user.sellerCity || ""}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                  </div>

                  <div>
                    <label htmlFor="sellerAdress" className="block text-sm font-semibold text-gray-700 mb-2">
                      Phone Number
                    </label>
                    <div className="phone-input-wrapper">
                      <PhoneInput
                        country={"us"}
                        value={user.sellerAdress || ""}
                        onChange={(phone) => setUser({ ...user, sellerAdress: phone })}
                        containerClass="!w-full"
                        dropdownClass="!z-50"
                      />
                    </div>
                  </div>
                </div>

                {/* Save Button */}
                <div className="flex justify-end pt-4 border-t border-gray-200">
                  <button
                    type="submit"
                    className="px-8 py-3 bg-[#34C3C9] hover:bg-[#2BB3BA] text-white font-semibold rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                  >
                    {lg?.savechgbtn || "Save Changes"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalSeller;
